import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AjaxService } from 'src/app/service/ajax.service';
import { API } from 'src/environments/environment';
import { createTextMaskInputElement } from 'text-mask-core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { UtilService } from 'src/app/service/util.service';

@Component({
  selector: 'app-coleta-tradutor',
  templateUrl: './coleta-tradutor.component.html',
  styleUrls: ['./coleta-tradutor.component.scss']
})
export class ColetaTradutorComponent implements OnInit {
  @ViewChild('successModal') successModal!: TemplateRef<any>;
  @ViewChild('errorModal') errorModal!: TemplateRef<any>;

  traducaoForm: FormGroup;
  outrasTraducoes: string = '';
  errorMessage: string ='';
  cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
  telefoneMask = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

  constructor(
    private fb: FormBuilder,
    private ajaxService: AjaxService,
    public modalService: NgbModal,
    private router: Router,
    private util: UtilService
  ) {
    this.traducaoForm = this.fb.group({
      nomeCompleto: ['', [Validators.required, Validators.minLength(3)]],
      cpf: ['', [Validators.required, Validators.pattern(/^\d{3}\.\d{3}\.\d{3}-\d{2}$/)]],
      email: ['', [Validators.required, Validators.email]],
      telefone: ['', [Validators.required, Validators.pattern(/^\(\d{2}\) \d{5}-\d{4}$/)]],
      endereco: ['', [Validators.required, Validators.minLength(10)]],
      ITA_POR: [false],
      POR_ITA: [false],
      OUT: [false],
      juramentado: [false, Validators.required]
    }, {
      validators: this.atLeastOneTranslationTypeValidator()
    });
  }

  ngOnInit(): void {
  }

  // Validador personalizado para verificar se pelo menos um tipo de tradução está selecionado
  private atLeastOneTranslationTypeValidator() {
    return (formGroup: FormGroup) => {
      const itaPor = formGroup.get('ITA_POR')?.value;
      const porIta = formGroup.get('POR_ITA')?.value;
      const out = formGroup.get('OUT')?.value;

      if (!itaPor && !porIta && !out) {
        return { atLeastOneTranslationType: true };
      }

      return null;
    };
  }

  // Getter para verificar se há erro de validação de tipo de tradução
  get hasTranslationTypeError(): boolean {
    return this.traducaoForm.hasError('atLeastOneTranslationType') && 
           (this.traducaoForm.get('ITA_POR')?.touched || 
            this.traducaoForm.get('POR_ITA')?.touched || 
            this.traducaoForm.get('OUT')?.touched);
  }

  navigateToSection(sectionId: string): void {
    this.router.navigate(['/site'], { fragment: sectionId });
  }

  login(): void {
    this.router.navigate(['/login']);
  }

  onSubmit() {
    if (this.traducaoForm.valid) {
      const formData = {
        ...this.traducaoForm.value,
        outrasTraducoes: this.outrasTraducoes
      };
      console.log('Form submitted:', formData);

      let dados = {        
        "NOME": formData.nomeCompleto,
        "CPF": formData.cpf,
        "EMAIL": formData.email,
        "TELEFONE": formData.telefone,
        "ENDERECO": formData.endereco,
        "TRAD_ITALIANO_PORTUGUES": formData.ITA_POR,
        "TRAD_PORTUGUES_ITALIANO": formData.POR_ITA,
        "TRAD_OUTRAS": formData.OUT,
        "JURAMENTADO": formData.juramentado ? "S" : "N",
        "OUTRAS_OBS": formData.outrasTraducoes
      }

      let url = API + "Usuario/Cadastro/tradutor";
      // Criar novo tradutor
      this.util.showLoading();
      this.ajaxService.post(url, dados).subscribe({
        next: (response) => {
          this.util.closeLoading();
          // Limpar o formulário
          this.traducaoForm.reset();
          this.outrasTraducoes = '';
          
          // Mostrar mensagem de sucesso
          this.modalService.open(this.successModal, { 
            centered: true,
            backdrop: 'static',
            keyboard: false
          });
        },
        error: (error) => {
          this.util.closeLoading();
          this.errorMessage = error.message;
          //console.error('Erro ao criar tradutor:', error);
          // Mostrar mensagem de erro
          this.modalService.open(this.errorModal, { 
            centered: true,
            backdrop: 'static',
            keyboard: false
          });
        }
      });
    }
  }

  // Getters para validação dos campos
  get nomeCompleto() { return this.traducaoForm.get('nomeCompleto'); }
  get cpf() { return this.traducaoForm.get('cpf'); }
  get email() { return this.traducaoForm.get('email'); }
  get telefone() { return this.traducaoForm.get('telefone'); }
  get endereco() { return this.traducaoForm.get('endereco'); }
} 